module.exports = __webpack_public_path__ + "static/media/boitesTupp_01_thumb_hover.773e4812.png";